/* global BigInt */
const ALPHABET =
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const BASE = 62n;

/**
 * Compress a UUID into a URL-safe base62 string (~22 chars).
 */
export function encodeUuid(uuid) {
  if (!uuid || typeof uuid !== "string") return null;
  const hex = uuid.replace(/-/g, "").toLowerCase();
  if (!/^[0-9a-f]{32}$/.test(hex)) return null;

  let n = BigInt(`0x${hex}`);
  if (n === 0n) return "0".padStart(22, "0");

  let encoded = "";
  while (n > 0n) {
    encoded = ALPHABET[Number(n % BASE)] + encoded;
    n /= BASE;
  }
  return encoded.padStart(22, "0");
}

/**
 * Expand a base62 compact id back to a dashed UUID.
 */
export function decodeUuid(encoded) {
  if (!encoded || typeof encoded !== "string") return null;

  let n = 0n;
  for (const ch of encoded) {
    const idx = ALPHABET.indexOf(ch);
    if (idx < 0) return null;
    n = n * BASE + BigInt(idx);
  }

  const hex = n.toString(16).padStart(32, "0");
  if (hex.length !== 32) return null;

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(
    12,
    16
  )}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function slugifyEventName(eventName) {
  if (!eventName) return "";
  return String(eventName).trim().split(/\s+/).join("-");
}
